import { IAccount, IVisibleUsers } from 'app/store/models/account.model';
import { DataSourceParams, ETableColumnType, ITableColumn } from 'app/store/models/table.model';
import { ViewRepresentativesStatusComponent } from '../../view-representatives/view-representatives-status/view-representatives-status.component';
import { StaticDataSource } from 'app/datasources/static.datasource';
import { Component, OnInit } from '@angular/core';
import { SessionService } from 'app/store/services/session.service';
import { UserType } from 'app/store/models/user.model';

@Component({
  selector: 'app-accounts-under',
  templateUrl: './accounts-under.component.html',
  styleUrls: ['./accounts-under.component.scss'],
})
export class AccountsUnderComponent implements OnInit {
  public items: any[];
  public ready = false;
  public account: IAccount;
  public emptyDataText = 'No data matching the filter.';

  dataSource: StaticDataSource<IVisibleUsers>;

  tableColumns: ITableColumn<IVisibleUsers>[] = [
    {
      id: 'first_name',
      title: 'First Name',
    },
    {
      id: 'last_name',
      title: 'Last Name',
    },
    {
      id: 'id',
      title: 'Account ID',
    },
    {
      id: 'email',
      title: 'Email',
    },
    {
      id: 'status',
      title: 'Status',
      hint: 'status_accounts',
      type: ETableColumnType.COMPONENT,
      componentProperties: {
        component: ViewRepresentativesStatusComponent,
        mapData: {
          account: {
            instance: 'column',
          },
        },
      },
    },
    {
      id: 'role',
      title: 'Role',
      renderer: row => {
        return row.account_role.charAt(0).toUpperCase() + row.account_role.slice(1);
      },
    },
  ];

  dataSourceParams: DataSourceParams = {
    page: 1,
    pageSize: 10,
    sortAttr: 'account_id',
    sortDir: 'desc',
    filters: {},
  };

  constructor(private readonly sessionService: SessionService) {
  }

  ngOnInit() {
    if (this.items) {
      if (this.account) {
        this.emptyDataText = `No subordinate users, assigned to this ${this.account.account_role}`;
      }
      this.appendPaidByColumnForAdmin();
      this.dataSource = new StaticDataSource(this.items);
      this.ready = true;
    }
  }

  private appendPaidByColumnForAdmin(): void {
    const session = this.sessionService.changes.getValue();
    if (session?.user_type !== UserType.MASTER) {
      return;
    }
    if (this.tableColumns.some(col => col.id === 'paid_by')) {
      return;
    }
    this.tableColumns = [
      ...this.tableColumns,
      {
        id: 'paid_by',
        title: 'Paid By',
        renderer: row => row.paid_by || '',
      },
    ];
  }
}
